import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent {
  isActivenonDisclosureAgreement:string= '';
constructor(@Inject(MAT_DIALOG_DATA) public data: {isActivenonDisclosureAgreement: string}, private dialogRef: MatDialogRef<TermsConditionComponent>){
  this.isActivenonDisclosureAgreement = this.data.isActivenonDisclosureAgreement;
}

close(isTrue: boolean){
  this.dialogRef.close(isTrue);
}
}
